<div class="separador text-center pb-5 pt-5">
  <h2 class="titulo ml-5 mb-5"><i>..."Proteger la vida que crece"...</i> Esta imagen nos fue entregada por nuestro
    obispo el
    cardenal Jorge Mario Bergoglio. Transcribimos aquí algunas de sus reflexiones: <br> <br> <i>...“José que se hace
      cargo de la vocación más honda en el corazón de todo hombre: ser padre. Padre es quien da la vida y ayuda
      a que la vida crezca... De ahí que, quien no quiera ser como José, termina siendo como Herodes... ”
    </i>
  </h2>
</div>
